const SubAbasDemandasInformacoes = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/home/demandasinformacoes/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasDemandasInformacoes;
